module.exports = __webpack_public_path__ + "static/media/aphrodite.aad2b785.jpg";